/** Gör om en titel till ett läsbart länknamn, t.ex. "Aktivera betalmetoder" -> "aktivera-betalmetoder". */
export const slugify = (value: string): string =>
  value
    .toLowerCase()
    .replace(/[àáâã]/g, 'a')
    .replace(/[åä]/g, 'a')
    .replace(/[èéêë]/g, 'e')
    .replace(/[ö]/g, 'o')
    .replace(/[üù]/g, 'u')
    .replace(/[^a-z0-9]+/g, '-')
    // Kapas före trimningen, så att en lång titel inte ger en slug som slutar på bindestreck.
    .slice(0, 200)
    .replace(/^-+|-+$/g, '');
